<!-- Cette card est utilisée dans la section "nos produits WAIS" -->

<template>
  <v-col cols="12" sm="6" md="4" lg="3">
    <v-card
      rounded="xl"
      elevation="2"
      class="text-center fill-height overflow-hidden card-product white black--text"
      :href="url"
      target="_blank"
      @mousedown="(e) => e.currentTarget.blur()"
    >
      <div class="pa-4 white--text" style="background-color: #bb1d77">
        <span class="text-h6 font-weight-bold">{{ title }}</span>
      </div>
      <v-img contain :src="image" height="180" class="my-6 mx-auto"></v-img>
      <v-card-text>
        <div class="text-body-1 grey--text mb-1">
          {{ $t("section_6_starting_from") }}
        </div>
        <div class="d-flex align-baseline justify-center primary--text">
          <span class="text-h3 font-weight-bold">{{ price }}</span>
          <span class="text-h5 grey--text font-weight-normal ml-2">
            {{ $t("section_6_tva_text") }}
          </span>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "baliseCard",
  props: {
    title: { type: String, required: true },
    image: { type: String, required: true },
    price: { type: String, required: true },
    url: { type: String, required: true },
  },
});
</script>

<style scoped>
.card-product {
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}
.card-product:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}
</style>
